import React from 'react'
import athhlogo from '../assets/images/athhlogo.svg'
import { FaLinkedin, FaEnvelope, FaTwitter, FaInstagram } from "react-icons/fa";
import { HiArrowNarrowRight } from "react-icons/hi";
import { Link } from 'react-router-dom';
import { FaUser } from "react-icons/fa";



function Footer() {

  const year = new Date().getFullYear()





  return (

    <>
      <div id='FooterDiv' className='centerParentDiv'>
        <div id='footerDesc' className='footerchilds'>
          <div id='logoAndMore'>
            <div className="logoImgOfFotter"><img src={athhlogo} alt="Athh logo" /></div>
            <div className="logoTextOfFooter"><h1>Athh Tech</h1><p>Where Future Begins</p></div>
          </div>
          <p id='footertext'>
            ATHH TECHNOLOGIES LLP is a creative digital agency based in india. We are composed of creative designers and experienced developers.
          </p>

          <div id='socialmediaParent'>
            <div>
              <a href="mailto:info@athh.co">
                <FaEnvelope className='footerIcon' />
              </a>
            </div>

            <div>
              <a href="https://www.instagram.com/athh_tech/?igshid=YmMyMTA2M2Y%3D" target="_blanck">
                <FaInstagram className='footerIcon' />
              </a>
            </div>

            <div>
              <a href="https://in.linkedin.com/company/athh-technologies-llp" target="_blanck">
                <FaLinkedin className='footerIcon' />
              </a>
            </div>

            <div>
              <a href="https://twitter.com/Athh_Tech" target="_blanck">
                <FaTwitter className='footerIcon' />
              </a>
            </div>

          </div>
        </div>
        <div className='footerchilds'>
          <h2 className='footer_head'>Helpful Links</h2>
          <ul>
            <Link to='/about'><li className=''>About us</li></Link>
            <Link to='/ourwork'><li className=''>Our work</li></Link>
            <Link to='/services'><li className=''>Services</li></Link>
            <Link to='/contact'><li className=''>Contact</li></Link>
          </ul>
        </div>
        <div className='footerchilds'>
          <h2 className='footer_head'>Services</h2>
          <ul id='serviceFotter'>
            <Link to='/servicesApp'><li>App development</li></Link>
            <Link to='/servicesBlock'><li>Blockchain</li></Link>
            <Link to='/servicesGame'><li>Game development</li></Link>
            <Link to='/servicesUiUx'><li>UI / UX Design</li></Link>
          </ul>
        </div>
        <div className='footerchilds'>
          <h2 className='footer_head'>Contact us</h2>
          <ul id='conUi'>
            <li><a href="mailto:info@athh.co" id='fotterMail'><FaEnvelope size={25} />&nbsp;&nbsp;&nbsp;info@athh.co</a></li>

            <li>
              <div className="liblueDiv">
                <FaUser size={20} className='conIcon' />
                <p id='liblue'><Link to='/contact'>CONTACT &nbsp;
                  <HiArrowNarrowRight className='conIcon' size={20} />
                </Link>

                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <center> <p id='footerGray'>© {year} Athh Technologies LLP. All Rights Reserved.</p></center>
    </>
  )
}

export default Footer